import { createSignal } from "solid-js";

interface ClickToCopyProps {
    text: string;
}

function ClickToCopy(props: ClickToCopyProps) {
    const [copied, setCopied] = createSignal(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(props.text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Hide the tooltip after 2 seconds
        });
    };

    return (
        <div class="relative max-w-full">
            <span class="text-white">Click to copy</span>
            <div
                class="cursor-pointer bg-gray-200 p-2 rounded hover:bg-gray-300 max-w-full overflow-scroll"
                onClick={handleCopy}
            >
                {props.text}
            </div>
            {copied() && (
                <div class="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs rounded p-1">
                    Copied!
                </div>
            )}
        </div>
    );
}

export default ClickToCopy;
